import { Alert } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import dayjs from "dayjs";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useGetUserSettingsQuery } from "src/service/UsersApi";

const showDeletionAccountAlertFlag = "isShowDeletionAccountAlert";
export const DeletionAccountAlert = () => {
  const { data } = useGetUserSettingsQuery();
  const { pathname } = useRouter();
  const [open, setOpen] = useState(false);
  const [canShow, setCanShow] = useState(false);

  const key = showDeletionAccountAlertFlag + data?.id;

  useEffect(() => {
    if (!data?.scheduledDeletionAt) {
      return;
    }
    const currentDate = new Date();
    const deleteDate = new Date(data.scheduledDeletionAt);
    setCanShow(deleteDate.getTime() - currentDate.getTime() > 0);
  }, [data]);

  useEffect(() => {
    if (pathname === "/mypage") {
      return setOpen(canShow);
    }
    if (canShow) {
      setOpen(localStorage.getItem(key) !== "1");
    } else {
      setOpen(false);
    }
  }, [pathname, key, canShow]);

  if (data?.isDeleted || !data?.scheduledDeletionAt || !open) {
    return null;
  }

  const onClose = () => {
    setOpen(false);
    localStorage.setItem(key, "1");
  };

  return (
    <Alert
      mt={10}
      mb={20}
      variant="filled"
      color="red"
      title="アカウント退会通知"
      icon={<IconInfoCircle />}
      withCloseButton={pathname !== "/mypage"}
      onClose={onClose}
    >
      このアカウントは{" "}
      {dayjs(data.scheduledDeletionAt).format("YY/MM/DD HH:mm")}{" "}
      まで利用可能で、その後は無効化されログインできなくなります。
    </Alert>
  );
};
